module.exports = __webpack_public_path__ + "img/lvshihuijianshenhe.d17ab002.png";